/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import {
    GetKnowledgeCenterApiParameter,
    getKnowledgeCenterItems as getKnowledgeCenterItemsApi,
} from "@eisinc/App/Services/KnowledgeCenterService";

import { ApiHandler, createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetKnowledgeCenterApiParameter, any>;


export const DispatchBeginLoadBlogs: HandlerType = (props: any) => {
    props.dispatch({
        type: "KnowledgeCenter/BeginLoadDocuments",
        isLoading: true,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const XngRequestDataFromKnowledgeCenterApi: HandlerType = async props => {
    props.apiResult = await getKnowledgeCenterItemsApi(props.apiParameter);
};

export const DispatchCompletedLoadBlogs: HandlerType = (props: any) => {
    const documents = props.apiResult?.documents;

    props.dispatch({
        type: "KnowledgeCenter/CompletedLoadDocuments",
        isLoading: false,
        documents,
    });
};

export const chain = [DispatchBeginLoadBlogs, PopulateApiParameter, XngRequestDataFromKnowledgeCenterApi, DispatchCompletedLoadBlogs];

const loadKnowledgeCenterItems = createHandlerChainRunner(chain, "LoadKnowledgeCenterItems");
export default loadKnowledgeCenterItems;
